'use strict';

/**
 * A facade for noUiSlider (http://refreshless.com/nouislider/)
 * which allows the use of jquery-ui slider api (http://api.jqueryui.com/slider/)
 *
 */
var _ = require('underscore');
var noUiSlider = require('nouislider');

var HORIZONTAL = 'horizontal';

var CHANGE_EVENT = 'change';
var CREATE_EVENT = 'create';
var SLIDE_EVENT = 'slide';
var START_EVENT = 'start';
var STOP_EVENT = 'stop';

var EVENT_NAMESPACE = 'sw-slider';
var CSS_PREFIX = 'sw-slider__';


/**
 * Re-registers an event if there's a handler
 * @param $el
 * @param eventName
 * @param eventHandler
 */
function cleanRegisterEvent($el, eventName, eventHandler) {
  var fullEventName = eventName + '.' + EVENT_NAMESPACE + ' slide' + eventName + '.' + EVENT_NAMESPACE;
  if(eventHandler) {
    $el.off(fullEventName).on(fullEventName, eventHandler);
  }
}

/**
 *
 * @param jqOpts
 * @param existingNoUiOpts
 * @returns {{animate: boolean, connect: *, orientation: *, range: {max: *, min: *}, start: *, step: *}}
 */
function mapJqOptionsToNoUiOptions(jqOpts, existingNoUiOpts) {
  //map jquery-ui range to connect value
  var connect = jqOpts.range;
  connect = connect === 'min' ? 'lower' : connect;
  connect = connect === 'max' ? 'upper' : connect;
  connect = !connect && jqOpts.values ? true : connect;

  var noUiOptions = {
    animate: !!jqOpts.animate,
    connect: connect,
    orientation: jqOpts.orientation,
    range: {
      max: jqOpts.max,
      min: jqOpts.min
    },
    start: jqOpts.values ? jqOpts.values : jqOpts.value,
    step: jqOpts.step
  };

  if(existingNoUiOpts) {
    noUiOptions.range = {
      max: _.isUndefined(jqOpts.max) ? existingNoUiOpts.range.max : jqOpts.max,
      min: _.isUndefined(jqOpts.min) ? existingNoUiOpts.range.min : jqOpts.min
    };
    noUiOptions = _.extend({}, existingNoUiOpts, noUiOptions);
  }

  // Start always needs to be an array
  noUiOptions.start = _.isNumber(noUiOptions.start) ? [noUiOptions.start] : noUiOptions.start;

  // Default direction for vertical is opposite of JqUi ... fix that
  noUiOptions.direction = noUiOptions.orientation === 'vertical' ? 'rtl' : 'ltr';

  return noUiOptions;
}

/**
 * Check to see if we're only setting value(s)
 *
 * @param _options
 * @returns {boolean}
 */
function onlySettingValue(_options) {
  var setters = _.keys(_options);
  return setters.length === 1 && (setters[0] === 'value' || setters[0] === 'values');
}

module.exports = function($) {

  /**
   * Triggers the jQuery Event
   * @param $el
   * @param event
   * @param values
   * @param handle
   */
  function triggerJqEvent($el, event, values, handle) {
    values = _.isArray(values) ? values : [values];
    values = _.map(values, parseFloat);
    var uiObj = {
      handle: $(handle),
      value:  values[0],
      values: values
    };
    $el.trigger(event, uiObj).trigger('slide' + event, uiObj);
  }

  /**
   * Makes a event listener that converts noUi events to JqUi events
   * @param $el
   * @param event
   * @returns function
   */
  function makeJqUiEventListener($el, event) {
    return function noUieventHandler(values, handle) {
      return triggerJqEvent($el, event, values, handle);
    };
  }

  /**
   * Facade for noUi to support jqueryui slider
   * @param options
   */
  $.fn.swSlider = function(options) {
    var $els = $(this);
    var readOnly = _.isString(options);
    var returnVal;

    // Only return the read of the first element
    if(readOnly && $els.length > 1) {
      $els = $($els[0]);
    }

    $els.each(function () {
      var $el = $(this);
      var el = $el[0];
      var noUiSliderEl = el.noUiSlider;
      var _options = !readOnly ? options : {};

      // we're making a new slider so set defaults
      if(!noUiSliderEl) {
        // Taken from the jquery-ui defaults http://api.jqueryui.com/slider/#options
        _options = _.defaults(_options, {
          animate: false,
          disabled: false,
          max: 100,
          min: 0,
          orientation: HORIZONTAL,
          range: false,
          step: 1,
          value: 0,
          values: null
        });
      } else if(onlySettingValue(_options)) {
        noUiSliderEl.set(_.first(_.values(_options)));
        return;
      }


      var exstNoUiOpt = noUiSliderEl ? noUiSliderEl.options : undefined;
      var noUiOptions = mapJqOptionsToNoUiOptions(_options, exstNoUiOpt);

      var values;
      if(readOnly) {
        values = noUiSliderEl.get();
        returnVal = (options === 'value' && !_.isUndefined(values[0])) ? values[0] : values;
      }

      // clean register any events we have
      cleanRegisterEvent($el, CHANGE_EVENT, _options.change);
      cleanRegisterEvent($el, CREATE_EVENT, _options.create);
      cleanRegisterEvent($el, SLIDE_EVENT, _options.slide);
      cleanRegisterEvent($el, START_EVENT, _options.start);
      cleanRegisterEvent($el, STOP_EVENT, _options.stop);

      if(noUiSliderEl) {
        noUiSliderEl.updateOptions(noUiOptions);
      } else {
        noUiOptions.cssPrefix = CSS_PREFIX;
        noUiSliderEl = noUiSlider.create(el, noUiOptions);
        // Register all events
        noUiSliderEl.on('slide', makeJqUiEventListener($el, SLIDE_EVENT));
        noUiSliderEl.on('change', makeJqUiEventListener($el, CHANGE_EVENT));
        noUiSliderEl.on('start', makeJqUiEventListener($el, START_EVENT));
        noUiSliderEl.on('end', makeJqUiEventListener($el, STOP_EVENT));

        // Trigger the create event right away
        triggerJqEvent($el, CREATE_EVENT, noUiSliderEl.get());
      }
    });

    return _.isUndefined(returnVal) ? this : returnVal;
  };

};
